import { MAP_LAYERS } from './layers';

/**
 * Le fond de carte choisi sur le suivi de la flotte est réutilisé tel quel sur
 * les autres cartes: même clé de stockage, donc un seul choix à faire.
 */
const CLE_PREFERENCES = 'fleet_map_prefs_v1';

/** Le fond enregistré s'il existe encore (le Satellite sans clé Esri n'existe pas). */
export function lireFondPrefere() {
  try {
    const brut = window.localStorage.getItem(CLE_PREFERENCES);
    const fond = brut ? JSON.parse(brut)?.layer : null;
    if (fond && MAP_LAYERS[fond]) return fond;
  } catch (erreur) {
    // Stockage indisponible: on prend le fond par défaut.
  }
  return MAP_LAYERS.satellite ? 'satellite' : 'streets';
}

export function enregistrerFondPrefere(fond) {
  try {
    const brut = window.localStorage.getItem(CLE_PREFERENCES);
    const actuel = brut ? JSON.parse(brut) || {} : {};
    window.localStorage.setItem(CLE_PREFERENCES, JSON.stringify({ ...actuel, layer: fond }));
  } catch (erreur) {
    // Sans stockage, le choix ne vaut que pour cette visite.
  }
}
